import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useSeo } from "@/lib/draft";

export default function RedefinirSenha() {
  useSeo("Redefinir senha", null, true);
  const [p] = useSearchParams();
  const [pwd, setPwd] = useState("");
  const [msg, setMsg] = useState("");
  const [ok, setOk] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) return setMsg("Mínimo de 8 caracteres.");
    try {
      await api.post("/auth/reset-password", { token: p.get("token"), password: pwd });
      setOk(true);
    } catch (e2) { setMsg(errMsg(e2)); }
  };
  return (
    <div className="wrap max-w-md py-12">
      <h1 className="text-3xl font-extrabold">Nova senha</h1>
      {ok ? (
        <p className="card mt-6" data-testid="reset-success">Senha alterada. <Link to="/entrar" className="font-bold text-[#1465C8]">Entrar</Link></p>
      ) : (
        <form onSubmit={submit} className="card mt-6 space-y-4">
          <input type="password" className="field" placeholder="Nova senha" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-password-input" />
          {msg && <p className="text-sm text-red-700" data-testid="reset-error">{msg}</p>}
          <button className="btn-primary w-full" data-testid="reset-submit-btn">Salvar</button>
        </form>
      )}
    </div>
  );
}
